import React from 'react';
import FAQ from '../FAQ/FAQ';
import { Container, PageItemsContainer } from './PageContainerStyle';
import VideoBlock from '../VideoBlock/VideoBlock';
import UbisoftPlusNavigation from '../UbisoftPlusNavigation/UbisoftPlusNavigation';
import RewardsBadgesBlock from '../RewardBadgesBlock/RewardsBadgesBlock';
import RedeemRewardBlock from '../RedeemRewardBlock/RedeemRewardBlock';
import PriceBannerBlock from '../PriceBannerBlock/PriceBannerBlock';
import KeepRewardsBlock from '../KeepRewardsBlock/KeepRewardsBlock';
import GameSliderBlock from '../GameSliderBlock/GameSliderBlock';
import CONFIG from '../../config';

const PageContainer = () => {
  return (
    <PageItemsContainer>
      {!CONFIG.isUPC && <UbisoftPlusNavigation />}
      <Container>
        <VideoBlock />
        <RewardsBadgesBlock />
        <RedeemRewardBlock />
        <KeepRewardsBlock />
      </Container>
      <GameSliderBlock />
      <PriceBannerBlock />
      <Container>
        <FAQ />
      </Container>
    </PageItemsContainer>
  );
};

export default PageContainer;